import React, { useState } from "react";
import BundleGroupUI from "./bundle_group.presenter";
export default function BundleGroup(_a) {
    var item = _a.item, isMinishop = _a.isMinishop;
    var currentItemID = item.item_id;
    var itemsCount = 0;
    var leftBundle = [];
    var rightBundle = [];
    /**
     * 닫기/열기 버튼 state
     */
    var _b = useState(false), isClosed = _b[0], setIsClosed = _b[1];
    /**
     * 닫기/열기 버튼 함수
     */
    var onClickToggleButton = function () {
        setIsClosed(!isClosed);
    };
    if ((item === null || item === void 0 ? void 0 : item.bundle_list) !== undefined) {
        itemsCount = item.bundle_list.length;
        /**
         *
         * 닫기 버튼 클릭 시에는 index가 10 이하인 경우까지만 데이터 생성(5줄만 노출 되야하기 때문)
         *
         * 좌측에는 index가 짝수인 경우의 데이터를 props로 전달
         * 우측에는 index가 홀수인 경우의 데이터를 props로 전달
         */
        leftBundle = item === null || item === void 0 ? void 0 : item.bundle_list.filter(function (item, index) { return (isClosed
            ? index % 2 === 0 && index < 10 && item
            : index % 2 === 0 && item); });
        rightBundle = item === null || item === void 0 ? void 0 : item.bundle_list.filter(function (item, index) { return (isClosed
            ? index % 2 !== 0 && index < 10 && item
            : index % 2 !== 0 && item); });
    }
    return (React.createElement(BundleGroupUI, { currentItemID: currentItemID, itemsCount: itemsCount, leftBundle: leftBundle, rightBundle: rightBundle, isMinishop: isMinishop, isClosed: isClosed, onClickToggleButton: onClickToggleButton }));
}



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/tab/bundle_group/bundle_group.container.tsx
// module id = 267
// module chunks = 0